/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentExport } from "./AgentExport";
import { Pagination } from "../../commons/types/Pagination";
export const ListAgentExportsResponse = core.serialization.object({
    data: core.serialization.list(AgentExport),
    pagination: Pagination,
});
